if (!customElements.get('free-shipping-bar')) {
  class FreeShippingBar extends HTMLElement {
    static cartHasFestoolItem(cart) {
      const items = cart?.items;
      if (!Array.isArray(items)) return false;
      return items.some((item) => {
        const vendor = String(item?.vendor || '')
          .toLowerCase()
          .trim();
        return vendor === 'festool';
      });
    }

    constructor() {
      super();

      this.threshold = parseFloat(this.dataset.threshold) || 200;
      this.text = this.querySelector('.free-shipping-text');
      this.progress = this.querySelector('.free-shipping-progress');

      this.updateQueued = false;
      this.boundHandleUpdate = this.handleCartUpdate.bind(this);
    }

    applyFestoolUnlocked(cart) {
      if (!this.text || !this.progress) return;
      this.progress.style.setProperty('--progress-width', '100%');
      this.text.innerHTML = `You've unlocked <strong>FREE SHIPPING!</strong> 🎉`;
      if (cart && typeof cart.item_count === 'number') {
        this.style.display = cart.item_count > 0 ? '' : 'none';
      }
    }

    connectedCallback() {
      document.addEventListener('cart:updated', this.boundHandleUpdate);

      if (this.dataset.hasFestool === 'true') {
        const initialTotal = parseFloat(this.dataset.initialTotal);
        this.applyFestoolUnlocked({
          item_count: !isNaN(initialTotal) && initialTotal > 0 ? 1 : 0
        });
        return;
      }

      const initialTotal = parseFloat(this.dataset.initialTotal);
      if (!isNaN(initialTotal)) {
        this.updateBar({
          total_price: initialTotal * 100,
          item_count: initialTotal > 0 ? 1 : 0
        });
      }
    }

    disconnectedCallback() {
      document.removeEventListener('cart:updated', this.boundHandleUpdate);
    }

    handleCartUpdate(event) {
      if (this.updateQueued) return;
      this.updateQueued = true;

						Promise.resolve().then(() => {
        const cart = event?.detail?.cartData;
        if (cart) this.updateBar(cart);
        this.updateQueued = false;
      });
    }

    updateBar(cart) {
      if (!this.text || !this.progress || !cart) return;

      if (FreeShippingBar.cartHasFestoolItem(cart)) {
        this.dataset.hasFestool = 'true';
        this.applyFestoolUnlocked(cart);
        return;
      }

      this.dataset.hasFestool = 'false';

      const cartTotal = (cart.total_price || 0) / 100;
      const remaining = Math.max(0, this.threshold - cartTotal);
      const percentage = Math.min(100, (cartTotal / this.threshold) * 100);

      this.progress.style.setProperty('--progress-width', `${percentage}%`);

      if (remaining > 0) {
        this.text.innerHTML = `You're $${remaining.toFixed(2)} away from <strong>FREE SHIPPING!</strong>`;
      } else {
        this.text.innerHTML = `You've unlocked <strong>FREE SHIPPING!</strong> 🎉`;
      }

      this.style.display = cart.item_count > 0 ? '' : 'none';
    }
  }

  customElements.define('free-shipping-bar', FreeShippingBar);
}
